import eventParking from './event-parking.png';
import eventFan from './event-fan.png';
import eventFood from './event-food.png';
import eventInfra from './event-infra.png';
import eventSecurity from './event-security.png';
import eventElectricity from './event-electricity.png'

import incidentParking from './incident-parking.png';
import incidentFan from './incident-fan.png';
import incidentFood from './incident-food.png';
import incidentInfra from './incident-infra.png';
import incidentSecurity from './incident-security.png';
import incidentElectricity from './incident-electricity.png'

import opAlertParking from './opAlert-parking.png';
import opAlertFan from './opAlert-fan.png';
import opAlertFood from './opAlert-food.png';
import opAlertInfra from './opAlert-infra.png';
import opAlertSecurity from './opAlert-security.png';
import opAlertElectricity from './opAlert-electricity.png'

import eventFanHover from './event-fan-hover.png';
import eventFoodHover from './event-food-hover.png';
import opAlertFanHover from './opAlert-fan-hover.png';
import opAlertFoodHover from './opAlert-food-hover.png';
import incidentFanHover from './incident-fan-hover.png';
import incidentFoodHover from './incident-food-hover.png';

export default {
    eventParking,
    eventFan,
    eventFood,
    eventFanHover,
    eventFoodHover,
    opAlertFanHover,
    opAlertFoodHover,
    eventInfra,
    eventSecurity,
    eventElectricity,
    incidentParking,
    incidentFan,
    incidentFood,
    incidentInfra,
    incidentSecurity,
    incidentElectricity,
    opAlertParking,
    opAlertFan,
    opAlertFood,
    opAlertInfra,
    opAlertSecurity,
    opAlertElectricity,
    incidentFanHover,
    incidentFoodHover,
};